import { render } from "./FileGallery.vue?vue&type=template&id=39988646&scoped=true"
import script from "./FileGallery.vue?vue&type=script&lang=js"
export * from "./FileGallery.vue?vue&type=script&lang=js"

import "./FileGallery.vue?vue&type=style&index=0&id=39988646&scoped=true&lang=css"

import exportComponent from "/home/www/.jenkins/workspace/131-front-vue-8081/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39988646"]])

export default __exports__